(() => {
const motionPreference=matchMedia('(prefers-reduced-motion: reduce)');
function init_hero(root){
const carousel=root.querySelector('.hero-carousel');
if(!carousel||carousel.dataset.ready)return;
const track=carousel.querySelector('.hero');
const slides=[...track.querySelectorAll('.hero-slide')];
if(!slides.length)return;
carousel.dataset.ready='true';
const configuredInterval=Number(carousel.dataset.slideInterval);
const slideInterval=(Number.isFinite(configuredInterval)&&configuredInterval>=2&&configuredInterval<=20?configuredInterval:6)*1000;
const indicators=[...carousel.querySelectorAll('.slide-indicator')];
const announcement=carousel.querySelector('.slide-announcement');
const count=slides.length,loop=count>1,offset=loop?count:0;
let active=0,elapsed=0,frame=null,lastFrame=null,settleTimer=null,resizeTimer=null;
let touching=false,scrolling=false,hovered=false,focused=false,editorPaused=false;
function copies(){
 return slides.map(slide=>{
  const copy=slide.cloneNode(true);
  copy.classList.add('hero-loop-copy');
  copy.classList.remove('is-active');
  copy.removeAttribute('id');copy.removeAttribute('data-shopify-editor-block');
  copy.setAttribute('aria-hidden','true');
  copy.querySelectorAll('[id]').forEach(el=>el.removeAttribute('id'));
  copy.querySelectorAll('a,button').forEach(el=>el.tabIndex=-1);
  return copy;
 });
}
if(loop){track.prepend(...copies());track.append(...copies());}
track.classList.add('hero-native-scroll');
function progress(){
 indicators.forEach((button,i)=>{
  button.querySelector('.indicator-progress').style.transform=`scaleX(${i<active?1:i===active?Math.min(elapsed/slideInterval,1):0})`;
 });
}
function update(index,announce=false){
 const next=((index%count)+count)%count;
 if(next!==active)elapsed=0;
 active=next;
 slides.forEach((slide,i)=>{
  slide.classList.toggle('is-active',i===active);
  slide.removeAttribute('inert');
  slide.setAttribute('aria-hidden',String(i!==active));
  slide.querySelectorAll('a,button').forEach(el=>el.tabIndex=i===active?0:-1);
  if(i===active)indicators[i]?.setAttribute('aria-current','true');else indicators[i]?.removeAttribute('aria-current');
 });
 if(announce&&announcement)announcement.textContent=`スライド ${active+1} / ${count}`;
 progress();
}
function nearest(){return Math.round(track.scrollLeft/track.clientWidth);}
function position(index,behavior='instant'){
 track.scrollTo({left:index*track.clientWidth,behavior});
}
function canPlay(){return loop&&carousel.isConnected&&!motionPreference.matches&&!document.hidden&&!editorPaused&&!hovered&&!focused&&!touching&&!scrolling;}
function playback(){
 if(frame!==null)cancelAnimationFrame(frame);
 frame=null;lastFrame=null;
 if(canPlay())frame=requestAnimationFrame(tick);
}
function tick(now){
 frame=null;
 if(!canPlay()){lastFrame=null;return;}
 if(lastFrame!==null)elapsed+=Math.max(0,now-lastFrame);
 lastFrame=now;
 if(elapsed>=slideInterval){
  elapsed=0;scrolling=true;
  position(nearest()+1,'smooth');
  scheduleSettle();return;
 }
 progress();frame=requestAnimationFrame(tick);
}
function settle(){
 clearTimeout(settleTimer);
 if(touching)return;
 const index=nearest();
 update(index-offset);
 if(loop&&(index<offset||index>=offset+count)&&Math.abs(track.scrollLeft-index*track.clientWidth)<2){
  position(offset+active);
 }
 scrolling=false;elapsed=0;playback();
}
function scheduleSettle(){clearTimeout(settleTimer);settleTimer=setTimeout(settle,180);}
function goTo(index,announce=true){
 elapsed=0;scrolling=true;playback();
 update(index,announce);
 position(offset+active,motionPreference.matches?'instant':'smooth');
 scheduleSettle();
}
indicators.forEach((button,i)=>{
 button.addEventListener('click',()=>goTo(i));
 button.addEventListener('keydown',event=>{
  if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
  event.preventDefault();
  const next=event.key==='Home'?0:event.key==='End'?count-1:(i+(event.key==='ArrowRight'?1:-1)+count)%count;
  goTo(next);indicators[next].focus();
 });
});
track.addEventListener('scroll',()=>{
 scrolling=true;playback();update(nearest()-offset);scheduleSettle();
},{passive:true});
track.addEventListener('scrollend',settle);
track.addEventListener('wheel',()=>{scrolling=true;playback();scheduleSettle();},{passive:true});
track.addEventListener('pointerdown',()=>{touching=true;playback();},{passive:true});
function release(){if(touching){touching=false;scheduleSettle();}}
addEventListener('pointerup',release,{passive:true});
addEventListener('pointercancel',release,{passive:true});
track.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'){hovered=true;playback();}});
track.addEventListener('pointerleave',()=>{hovered=false;playback();});
track.addEventListener('focusin',()=>{focused=true;playback();});
track.addEventListener('focusout',event=>{focused=track.contains(event.relatedTarget);playback();});
document.addEventListener('visibilitychange',playback);
motionPreference.addEventListener('change',playback);
carousel.addEventListener('shopify:block:select',()=>{editorPaused=true;playback();});
carousel.addEventListener('shopify:block:deselect',()=>{editorPaused=false;playback();});
addEventListener('resize',()=>{
 clearTimeout(resizeTimer);
 resizeTimer=setTimeout(()=>{position(offset+active);scheduleSettle();},150);
});
update(0);position(offset);playback();
}
function init_products(root){
// Match the centered second card in the mobile reference; keep native swipe scrolling.
const mobileLayout=matchMedia('(max-width: 640px)');
function alignMobileCards(){
 root.querySelectorAll('.product-grid').forEach(track=>{
  const card=track.children[1];
  if(mobileLayout.matches&&card){track.scrollLeft=card.offsetLeft-track.offsetLeft-(track.clientWidth-card.offsetWidth)/2;}
  else track.scrollLeft=0;
 });
}
requestAnimationFrame(alignMobileCards);
mobileLayout.addEventListener('change',alignMobileCards);


}
function init_news(root){
const mobileLayout=matchMedia('(max-width: 640px)');
// Three copies let native touch scrolling pass either end without a visible rewind.
const newsTrack=root.querySelector('.news-grid');if(!newsTrack||newsTrack.dataset.ready||!newsTrack.children.length)return;newsTrack.dataset.ready='true';
const newsOriginals=[...newsTrack.children];
const newsTotal=newsOriginals.length;
const newsPagination=document.createElement('p');
newsPagination.className='news-pagination';newsPagination.setAttribute('aria-live','polite');newsPagination.setAttribute('aria-atomic','true');
newsTrack.after(newsPagination);
let newsActive=0,newsSettleTimer,newsTouching=false,newsLoopReady=false;
function newsCopies(){
 return newsOriginals.map((original,index)=>{
  const copy=original.cloneNode(true);copy.classList.add('news-loop-copy');copy.classList.remove('reveal-pending','motion-reveal');copy.setAttribute('aria-hidden','true');
  copy.querySelectorAll('[id]').forEach(el=>el.removeAttribute('id'));
  copy.querySelectorAll('button,a').forEach(el=>el.tabIndex=-1);
  
  return copy;
 });
}
function newsCenter(card){const r=card.getBoundingClientRect(),t=newsTrack.getBoundingClientRect();return newsTrack.scrollLeft+r.left-t.left-(newsTrack.clientWidth-r.width)/2;}
function updateNewsCount(){newsPagination.textContent=`${newsActive+1}/${newsTotal}`;newsPagination.setAttribute('aria-label',`全${newsTotal}件中${newsActive+1}件目`);}
function positionNews(card){
 newsTrack.classList.add('is-repositioning');
 const destination=newsCenter(card);newsTrack.scrollLeft=destination;
 void newsTrack.offsetWidth;
 requestAnimationFrame(()=>requestAnimationFrame(()=>{newsTrack.classList.remove('is-repositioning');newsTrack.scrollLeft=destination;}));
}
function nearestNews(){
 const cards=[...newsTrack.children],center=newsTrack.getBoundingClientRect().left+newsTrack.clientWidth/2;
 let closest=0,distance=Infinity;
 cards.forEach((card,i)=>{const r=card.getBoundingClientRect(),d=Math.abs(r.left+r.width/2-center);if(d<distance){closest=i;distance=d;}});
 return closest;
}
function settleNews(){
 if(!mobileLayout.matches||!newsLoopReady||newsTouching)return;
 const index=nearestNews();newsActive=((index-newsTotal)%newsTotal+newsTotal)%newsTotal;updateNewsCount();
 if(index<newsTotal||index>=newsTotal*2)positionNews(newsOriginals[newsActive]);
}
function configureNews(){
 clearTimeout(newsSettleTimer);
 if(mobileLayout.matches){
  if(!newsLoopReady){newsTrack.prepend(...newsCopies());newsTrack.append(...newsCopies());newsLoopReady=true;}
  requestAnimationFrame(()=>positionNews(newsOriginals[newsActive]));
 }else{
  newsTrack.querySelectorAll('.news-loop-copy').forEach(el=>el.remove());newsLoopReady=false;newsTrack.scrollLeft=0;
 }
 updateNewsCount();
}
newsTrack.addEventListener('scroll',()=>{
 if(!mobileLayout.matches||!newsLoopReady)return;
 const index=nearestNews();newsActive=((index-newsTotal)%newsTotal+newsTotal)%newsTotal;updateNewsCount();
 clearTimeout(newsSettleTimer);newsSettleTimer=setTimeout(settleNews,180);
},{passive:true});
newsTrack.addEventListener('scrollend',settleNews);
newsTrack.addEventListener('pointerdown',()=>{newsTouching=true;});
function releaseNews(){if(newsTouching){newsTouching=false;clearTimeout(newsSettleTimer);newsSettleTimer=setTimeout(settleNews,200);}}
addEventListener('pointerup',releaseNews);addEventListener('pointercancel',releaseNews);
newsTrack.addEventListener('keydown',e=>{
 if(!mobileLayout.matches||!['ArrowLeft','ArrowRight'].includes(e.key))return;
 e.preventDefault();const index=nearestNews()+(e.key==='ArrowRight'?1:-1),card=newsTrack.children[index];
 if(card)newsTrack.scrollTo({left:newsCenter(card),behavior:motionPreference.matches?'instant':'smooth'});
});
mobileLayout.addEventListener('change',configureNews);
let newsResizeTimer;addEventListener('resize',()=>{clearTimeout(newsResizeTimer);newsResizeTimer=setTimeout(configureNews,150);});
configureNews();


}
function init_logo(root){
// Play once when the large technology logo is comfortably inside the viewport.
const drawnMoon=root.querySelector('.moon-draw');
if(drawnMoon&&'IntersectionObserver' in window){
 const logoHeading=drawnMoon.closest('h2');
 logoHeading.classList.remove('motion-reveal','reveal-pending');
 let moonObserver;
 function configureMoonDraw(){
  moonObserver?.disconnect();
  if(motionPreference.matches){drawnMoon.classList.remove('draw-ready','is-drawing');return;}
  if(drawnMoon.dataset.played)return;
  drawnMoon.classList.add('draw-ready');
  moonObserver=new IntersectionObserver(entries=>{
   if(!entries.some(entry=>entry.isIntersecting))return;
   drawnMoon.classList.add('is-drawing');drawnMoon.dataset.played='true';moonObserver.disconnect();
  },{threshold:.7,rootMargin:'0px 0px -8% 0px'});
  moonObserver.observe(drawnMoon);
 }
 configureMoonDraw();motionPreference.addEventListener('change',configureMoonDraw);
}

}
function init(root){init_hero(root);init_products(root);init_news(root);init_logo(root);}
init(document);document.addEventListener('shopify:section:load',event=>init(event.target));
document.addEventListener('shopify:block:select',event=>{const slide=event.target.closest('.hero-slide');if(slide){const carousel=slide.closest('.hero-carousel');const index=[...carousel.querySelectorAll('.hero-slide:not(.hero-loop-copy)')].indexOf(slide);carousel.querySelectorAll('.slide-indicator')[index]?.click();}});
})();
